import { DEFAULT_LOCALE, LOCALE_STORAGE_KEY, normalizeLocale, type Locale } from './locales';

/**
 * Detects the UI locale using the following cascade:
 *  1. `lang` parameter handed over by the embedding host page (iframe src query)
 *  2. Stored choice in localStorage
 *  3. First supported match from navigator.languages
 *  4. DEFAULT_LOCALE ("de")
 *
 * Storage access is guarded: a cross-site iframe may have storage disabled.
 */
export function detectLocale(search: string = window.location.search): Locale {
  const requested = new URLSearchParams(search).get('lang');
  if (requested) {
    const match = normalizeLocale(requested);
    if (match) return match;
  }

  try {
    const stored = localStorage.getItem(LOCALE_STORAGE_KEY);
    if (stored) {
      const match = normalizeLocale(stored);
      if (match) return match;
    }
  } catch {
    // Storage unavailable (private mode / partitioned iframe) — fall through.
  }

  for (const lang of navigator.languages ?? []) {
    const match = normalizeLocale(lang);
    if (match) return match;
  }

  return DEFAULT_LOCALE;
}
